// For connecting flights, pick the last segment's booking class that matches the
// selected fare's own resBookDesigCode, so every segment is booked in the same RBD.
export const resolveConnectingBookingClass = (
  segmentClasses,
  selectedClass,
  index,
  fareComponent,
  segmentCount
) => {
  const classes = Array.isArray(segmentClasses)
    ? segmentClasses
    : segmentClasses
    ? [segmentClasses]
    : [];
  const atIndex = classes[index];

  const passengerFares = fareComponent?.passengerFareInfoList;
  const firstPassengerFare = Array.isArray(passengerFares)
    ? passengerFares[0]
    : passengerFares;
  const fareInfos = firstPassengerFare?.fareInfoList;
  const segmentFareInfo =
    Array.isArray(fareInfos) && fareInfos.length >= segmentCount
      ? fareInfos[segmentCount - 1]
      : null;

  if (segmentFareInfo?.resBookDesigCode) {
    let matches = classes.filter(
      (bc) => bc?.resBookDesigCode === segmentFareInfo.resBookDesigCode
    );
    if (segmentFareInfo.fareGroupName) {
      const sameFamily = matches.filter(
        (bc) => bc?.fareGroupName === segmentFareInfo.fareGroupName
      );
      if (sameFamily.length) {
        matches = sameFamily;
      }
    }
    if (matches.length) {
      return matches.includes(atIndex) ? atIndex : matches[0];
    }
  }

  if (atIndex && atIndex.fareGroupName === selectedClass?.fareGroupName) {
    return atIndex;
  }

  if (selectedClass?.fareGroupName) {
    const sameFamily = classes.filter(
      (bc) =>
        bc?.fareGroupName === selectedClass.fareGroupName &&
        bc?.cabin === selectedClass.cabin
    );
    if (sameFamily.length === 1) {
      return sameFamily[0];
    }
  }

  return atIndex || classes[0] || selectedClass;
};
